<template>
  <v-app>
    <v-navigation-drawer
        app
        v-bind:temporary="drawerTemporary"
        v-model="drawer"
        width="265" style="z-index: 1002;"
    >
      <v-toolbar dark class="app-toolbar" height="70px">
        <v-list>
          <v-list-tile>
            <v-list-tile-content class="subheading text-xs-center">
              <span class="drower-toolbar-content pa-0">{{getCurrentData()}}</span>
              <span class="drower-toolbar-content pa-0">{{getWeekDay()}}, неделя {{getCurrentWeek()}}/{{getWeeksInYear()}}</span>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list v-if="isUserLoggedIn">
        <v-list-tile :to="homeLink.url">
          <v-list-tile-action class="drawer-home">
            <v-icon>{{homeLink.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{homeLink.title}}</v-list-tile-title>
        </v-list-tile>

        <v-list-group
            v-for="group in drawerLinks"
            v-if="isAccess(group.accessId)"
            :key="group.title"
            :prepend-icon="group.icon"
            no-action
        >
          <v-list-tile slot="activator" class="drawer-link">
            <v-list-tile-title v-if="group.title !== 'Торговые точки'">{{group.title}}</v-list-tile-title>
            <v-list-tile-title v-if="group.title === 'Торговые точки'">
              {{group.title}}
              <v-badge color="primary" class="points-budge" v-if="pointLogistics + pointSecurity > 0 && isAccess([7,8])"><span slot="badge">{{ pointLogistics + pointSecurity }}</span></v-badge>
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-for="subLink in group.subLinks"
            v-if="typeof subLink.accessId !== 'undefined' ? isAccess(subLink.accessId) : true"
            :key="subLink.title"
            :to="subLink.url"
            class="drawer-sublink"
          >
            <v-list-tile-title v-if="subLink.accessId !== 7 && subLink.accessId !== 8">{{subLink.title}}</v-list-tile-title>
            <v-list-tile-title v-if="subLink.accessId === 8">
              {{subLink.title}}
              <v-badge color="primary" class="points-budge" v-if="pointLogistics != 0"><span slot="badge">{{ pointLogistics }}</span></v-badge>
            </v-list-tile-title>
            <v-list-tile-title v-if="subLink.accessId === 7">
              {{subLink.title}}
              <v-badge color="primary" class="points-budge" v-if="pointLogistics != 0"><span slot="badge">{{ pointSecurity }}</span></v-badge>
            </v-list-tile-title>
          </v-list-tile>
        </v-list-group>
        <v-list-tile :to="chatLink.url" v-if="isAccess(chatLink.accessId)">
          <v-list-tile-action class="drawer-home">
            <v-icon>{{chatLink.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{chatLink.title}}
            <v-badge color="primary" class="points-budge" v-if="chatLink.unreadCount > 0"><span slot="badge">{{ chatLink.unreadCount }}</span></v-badge>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile :to="settingsLink.url" v-if="isAccess(settingsLink.accessId)">
          <v-list-tile-action class="drawer-home">
            <v-icon>{{settingsLink.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{settingsLink.title}}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
            to="/users/self/info"
            class="drawer-sublink hidden-sm-and-up"
        >
          <v-list-tile-title>Личные данные</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
            class="drawer-sublink hidden-sm-and-up"
            @click="onLogout"
        >
          <v-list-tile-title>Выход</v-list-tile-title>
        </v-list-tile>
      </v-list>

      <v-list v-if="!isUserLoggedIn">
        <v-list-tile :to="loginLink.url">
          <v-list-tile-action>
            <v-icon>{{loginLink.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{loginLink.title}}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app dark class="app-toolbar" v-if="isUserLoggedIn" height="70px" style="z-index: 1001;">
      <v-toolbar-side-icon
        @click="drawer = !drawer"
      ></v-toolbar-side-icon>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only">

        <v-btn
            :to="'/users/self/info'"
            flat
            v-if="isUserLoggedIn"
        >
          <v-avatar class="mr-3">
            <img :src="user.photo.url_resized">
          </v-avatar>
          {{ user.surname }} {{ user.first_name }} {{ user.patronymic }}
        </v-btn>

        <v-btn
            @click="onLogout"
            flat
            v-if="isUserLoggedIn"
        >
          <v-icon left>exit_to_app</v-icon>
          Выход
        </v-btn>

        <v-btn
            :to="loginLink.url"
            flat
            v-if="!isUserLoggedIn"
        >
          <v-icon left>{{loginLink.icon}}</v-icon>
          {{loginLink.title}}
        </v-btn>

      </v-toolbar-items>
    </v-toolbar>

    <v-content>
      <template>
        <v-progress-linear :indeterminate="true" class="ma-0 pa-0" v-if="pageLoading"></v-progress-linear>
        <div class="progress-blank" v-if="!pageLoading"></div>
      </template>
      <router-view></router-view>
    </v-content>

    <template v-if="error">
      <v-snackbar
          :timeout="0"
          :multi-line="true"
          color="error"
          @input="closeError"
          :value="true"
          :auto-height="true"
      >
        <div v-html="error"></div>
        <v-btn flat @click.native="closeError" class="snackbar-btn"><v-icon>cancel</v-icon></v-btn>
      </v-snackbar>
    </template>

    <template v-if="success">
      <v-snackbar
          :timeout="0"
          :multi-line="true"
          color="success"
          @input="closeSuccess"
          :value="true"
      >
        {{success}}
        <v-btn flat @click.native="closeSuccess" class="snackbar-btn"><v-icon>cancel</v-icon></v-btn>
      </v-snackbar>
    </template>

  </v-app>
</template>

<script>
  import HelpMixin from './mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        drawer: true,
        homeLink: {title: 'Домой', icon: 'home', url: '/'},
        settingsLink: {title: 'Настройки', icon: 'settings', accessId: 12, url: '/settings'},
        chatLink: {title: 'Чат', icon: 'chat', url: '/chat', accessId: 12, unreadCount: 0},
        loginLink: {title: 'Вход', icon: 'lock', url: '/login'},
        drawerLinks: [
          {
            title: 'Сообщения',
            icon: 'mail_outline',
            accessId: 2,
            subLinks: [
              {title: 'Планируемые', url: '/notifications/future'},
              {title: 'Архив', url: '/notifications/past'},
              {title: 'Создать новое', url: '/notifications/new'}
            ]
          },
          {
            title: 'Ограничения',
            icon: 'not_interested',
            accessId: 3,
            subLinks: [
              {title: 'Активные', url: '/restrictions/active'},
              {title: 'Архив', url: '/restrictions/past'},
              {title: 'Создать новое', url: '/restrictions/new'}
            ]
          },
          {
            title: 'Кейсы',
            icon: 'work',
            accessId: 5,
            subLinks: [
              {title: 'Активные', url: '/cases/active'},
              {title: 'Архив', url: '/cases/past'},
              {title: 'Создать новый', url: '/cases/new'}
            ]
          },
          {
            title: 'Рекомендации',
            icon: 'thumb_up_alt',
            accessId: 11,
            subLinks: [
              {title: 'Активные', url: '/recommendations/active'},
              {title: 'Архив', url: '/recommendations/past'},
              {title: 'Создать новую', url: '/recommendations/new'}
            ]
          },
          {
            title: 'Мониторинг',
            icon: 'search',
            accessId: 15,
            subLinks: [
              {title: 'Активные', url: '/monitorings/active'},
              {title: 'Архив', url: '/monitorings/past'},
              {title: 'Отчёт', url: '/monitorings/report'},
              {title: 'Создать новый', url: '/monitorings/new'}
            ]
          },
          {
            title: 'Агенты',
            icon: 'people',
            accessId: 9,
            subLinks: [
              {title: 'Активность', url: '/agents/activity'},
              {title: 'Рейтинг', url: '/agents/rating'}
            ]
          },
          {
            title: 'Водители',
            icon: 'local_shipping',
            accessId: 14,
            subLinks: [
              {title: 'Карта', url: '/drivers/activity'},
              {title: 'Таблица', url: '/drivers/rating'}
            ]
          },
          {
            title: 'Торговые точки',
            icon: 'location_on',
            accessId: [7, 8],
            subLinks: [
              // {title: 'Активные точки', url: '/points/active', accessId: 1},
              {title: 'Заявки (Логист)', url: '/points/request/logistics/list', accessId: 8},
              {title: 'Заявки (СБ)', url: '/points/request/security/list', accessId: 7},
              {title: 'Архив заявок', url: '/points/request/archive', accessId: [7, 8]}
            ]
          },
          {
            title: 'Скрытие остатков',
            icon: 'assignment_turned_in',
            accessId: 10,
            subLinks: [
              {title: 'Активные', url: '/product/stock/setting/active'},
              {title: 'Создать', url: '/product/stock/setting/new'}
            ]
          },
          {
            title: 'Пользователи',
            icon: 'account_box',
            accessId: 4,
            subLinks: [
              {title: 'Активные', url: '/users/active'},
              {title: 'Архив', url: '/users/past'},
              {title: 'Создать нового', url: '/users/new'}
            ]
          },
          {
            title: 'Группы',
            icon: 'how_to_reg',
            accessId: 10,
            subLinks: [
              {title: 'Список групп', url: '/users/group/list'},
              {title: 'Создать группу', url: '/users/group/new'}
            ]
          },
          {
            title: 'Статистика',
            icon: 'show_chart',
            accessId: 13,
            subLinks: [
              {title: 'Филиалы', url: '/statistics/branch'},
              {title: 'Группы продаж', url: '/statistics/sale-group'},
              {title: 'Агенты', url: '/statistics/agent'},
              {title: 'Каналы продаж', url: '/statistics/distribution-channel'},
              {title: 'Торговые точки', url: '/statistics/point'},
              {title: 'Категории', url: '/statistics/product-category'},
              {title: 'Бренды', url: '/statistics/product-brand'},
              {title: 'SKU', url: '/statistics/product-sku'}
            ]
          }
        ]
      }
    },
    computed: {
      success () {
        return this.$store.getters.success
      },
      error () {
        return this.$store.getters.error
      },
      isUserLoggedIn () {
        return this.$store.getters.isUserLoggedIn
      },
      drawerTemporary () {
        if (window.innerWidth >= 720 && this.isUserLoggedIn) {
          this.drawer = true
          return false
        } else {
          this.drawer = false
          return true
        }
      },
      user () {
        return this.$store.getters.user
      },
      pageTitle () {
        return this.$store.getters.pageTitle
      },
      pageLoading () {
        return this.$store.getters.pageLoading
      },
      pointLogistics () {
        return this.$store.getters.pointLogistics
      },
      pointSecurity () {
        return this.$store.getters.pointSecurity
      }
    },
    created () {
      this.setCountersUserUpdater()
    },
    methods: {
      isAccess (accessId) {
        if (typeof this.user.user_group.access_list !== 'undefined') {
          if (Array.isArray(accessId)) {
            for (let i = 0; i < accessId.length; i++) {
              for (let k = 0; k < this.user.user_group.access_list.length; k++) {
                if (accessId[i] === this.user.user_group.access_list[k].id) {
                  return true
                }
              }
            }
          } else {
            for (let i = 0; i < this.user.user_group.access_list.length; i++) {
              if (accessId === this.user.user_group.access_list[i].id) {
                return true
              }
            }
          }
        }
        return false
      },
      closeSuccess () {
        this.$store.dispatch('clearSuccess')
      },
      closeError () {
        this.$store.dispatch('clearError')
      },
      onLogout () {
        this.$store.dispatch('logoutUser')
      },
      getWeekDay () {
        let date = new Date()
        let weekday = date.toLocaleString('ru', {weekday: 'long'})
        return weekday[0].toUpperCase() + weekday.slice(1)
      },
      getCurrentData () {
        let date = new Date()
        return date.toLocaleDateString()
      },
      getCurrentWeek () {
        let currentDateTime = new Date()
        let startTimeOfCurrentYear = (new Date(currentDateTime.getFullYear(), 0, 1)).getTime()
        let currentTime = currentDateTime.getTime()
        let pastTimeOfStartCurrentYear = currentTime - startTimeOfCurrentYear
        let hourOfMillisecs = 3600000
        let hoursOfOneWeek = 168
        let currntWeek = (pastTimeOfStartCurrentYear / hourOfMillisecs / hoursOfOneWeek).toFixed(2)
        return Math.floor(currntWeek)
      },
      getWeeksInYear () {
        let year = new Date().getFullYear()
        let month = 11
        let day = 31
        let week

        do {
          let d = new Date(+new Date(year, month, day--))
          d.setHours(0, 0, 0)
          d.setDate(d.getDate() + 4 - (d.getDay() || 7))
          let yearStart = new Date(d.getFullYear(), 0, 1)
          let weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
          week = [d.getFullYear(), weekNo][1]
        } while (week === 1)

        return week
      },
      setCountersUserUpdater () {
        setInterval(() => {
          if (this.user !== null) {
            this.$store.dispatch('countersUser')
          }
        }, 1000 * 30)
      }
    },
    watch: {
      '$store.getters.accessToken' (newToken, oldToken) {
        if (this.$store.getters.accessToken !== null) {
          switch (this.$route.path) {
            case '/login':
              this.$router.push('/')
              break
            case '/password-recovery':
              this.$router.push('/')
              break
            case '/password-recovery/confirm':
              this.$router.push('/')
              break
          }
        } else {
          this.$router.push('/login')
        }
      },
      '$route' (to, from) {
        this.scrollUp()

        if (this.$store.getters.accessToken === null) {
          switch (this.$route.path) {
            case '/login':
              break
            case '/password-recovery':
              break
            case '/password-recovery/confirm':
              break
            default:
              this.$router.push('/login')
              break
          }
        }

        if (typeof this.$route.meta.accessId !== 'undefined') {
          if (!this.isAccess(this.$route.meta.accessId)) {
            this.$store.commit('setError', 'Нет доступа')
            this.$router.push('/')
          }
        }
      },
      user (val) {
        if (typeof this.$route.meta.accessId !== 'undefined') {
          if (!this.isAccess(this.$route.meta.accessId)) {
            this.$store.commit('setError', 'Нет доступа')
            this.$router.push('/')
          }
        }

        if (this.user !== null) {
          this.$store.dispatch('countersUser')
          // this.$store.dispatch('createChatSocket')
        } else {
          // this.$store.dispatch('closeChatSocket')
        }
      },
      pageTitle (val) {
        let title = document.getElementsByTagName('title')[0]
        title.innerHTML = this.pageTitle
      },
      '$store.getters.unreadCount' () {
        this.chatLink.unreadCount = this.$store.getters.unreadCount
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue